/* Refresh Cars — minimal cart + UI helpers */
(function () {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  // Minimal toast helper (non-blocking replacement for alert)
  function showToast(msg, type) {
    try {
      var t = document.createElement('div');
      t.setAttribute('role', type === 'error' ? 'alert' : 'status');
      t.setAttribute('aria-live', type === 'error' ? 'assertive' : 'polite');
      t.textContent = String(msg || '');
      t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);' +
        'z-index:10000;max-width:90vw;padding:12px 16px;border-radius:10px;' +
        'background:' + (type === 'error' ? '#b91c1c' : '#0a0a0a') + ';color:#fff;' +
        'font:500 14px/1.35 system-ui,sans-serif;box-shadow:0 8px 24px rgba(0,0,0,0.18);' +
        'opacity:0;transition:opacity .25s ease;';
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.style.opacity = '1'; });
      setTimeout(function () {
        t.style.opacity = '0';
        setTimeout(function () { try { t.remove(); } catch (e) {} }, 300);
      }, 4000);
    } catch (e) { if (window.console) console.warn('toast failed', e); }
  }
  window.rcToast = showToast;

  // Scroll-lock robusto iOS: body{overflow:hidden} NO congela el scroll en iOS Safari.
  // Fija el body en position:fixed guardando/restaurando scrollY.
  var _rcScrollY = 0;
  function rcLockScroll(){ _rcScrollY = window.scrollY || window.pageYOffset || 0; document.body.style.position='fixed'; document.body.style.top='-'+_rcScrollY+'px'; document.body.style.left='0'; document.body.style.right='0'; document.body.style.width='100%'; document.body.classList.add('drawer-open'); }
  function rcUnlockScroll(){ document.body.classList.remove('drawer-open'); document.body.style.position=''; document.body.style.top=''; document.body.style.left=''; document.body.style.right=''; document.body.style.width=''; window.scrollTo(0, _rcScrollY); }
  window.rcLockScroll = rcLockScroll; window.rcUnlockScroll = rcUnlockScroll;

  // Persistencia ligera para personalized hero + segment-aware popup
  (function trackPath(){
    var path = location.pathname;
    var mProd = path.match(/^\/products\/([^\/?#]+)/);
    var mColl = path.match(/^\/collections\/([^\/?#]+)/);
    var thirtyDays = 60 * 60 * 24 * 30;
    if (mProd) document.cookie = 'rc_last_prod=' + encodeURIComponent(mProd[1]) + '; path=/; max-age=' + thirtyDays;
    if (mColl && mColl[1] !== 'all') document.cookie = 'rc_last_cat=' + encodeURIComponent(mColl[1]) + '; path=/; max-age=' + thirtyDays;
  })();

  // Toggle mobile menu drawer
  document.addEventListener('click', (e) => {
    const menu = $('[data-mobile-menu]');
    if (e.target.closest('[data-menu-toggle]')) {
      e.preventDefault();
      menu?.classList.add('is-open');
      menu?.setAttribute('aria-hidden', 'false');
      document.body.classList.add('menu-open');
      rcLockScroll();
      document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'true');
      return;
    }
    if (e.target.closest('[data-menu-close]')) {
      menu?.classList.remove('is-open');
      menu?.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('menu-open');
      rcUnlockScroll();
      document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    }
  });

  // Close menu on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const menu = $('[data-mobile-menu]');
    if (menu?.classList.contains('is-open')) {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('menu-open');
      rcUnlockScroll();
      document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    }
  });

  // Cart drawer toggle
  let drawer = $('[data-cart-drawer]');
  document.addEventListener('click', (e) => {
    drawer = $('[data-cart-drawer]'); // re-query in case it was re-rendered
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      drawer?.classList.add('is-open');
      rcLockScroll();
    }
    if (e.target.closest('[data-cart-close]') || e.target.matches('[data-cart-overlay]')) {
      drawer?.classList.remove('is-open');
      rcUnlockScroll();
    }
  });

  // Add to cart via AJAX — INSTANTÁNEO: abre drawer + skeleton, refresca en paralelo
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    // Guard anti doble-add: evita peticiones duplicadas en doble-tap mobile
    if (window.__rcAdding) return;
    window.__rcAdding = true;
    const btn = form.querySelector('button[name="add"], button[type="submit"]:not([data-buy-now])');
    let originalHTML = null;
    if (btn) {
      originalHTML = btn.innerHTML;
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('disabled', 'true');
    }
    // Abre drawer INSTANTÁNEO con skeleton de carga (oculta contenido viejo)
    drawer = $('[data-cart-drawer]');
    drawer?.classList.add('is-open');
    drawer?.classList.add('is-loading');
    rcLockScroll();
    try {
      const fd = new FormData(form);
      await runCartOp(function () {
        return withGiftless(async () => {
          const r = await fetch('/cart/add.js', { method: 'POST', body: fd });
          if (!r.ok) {
            // Per docs, si la cantidad excede el stock Shopify AÑADE el máximo disponible Y
            // responde 422: es un éxito PARCIAL. Guardar el mensaje para mostrarlo (no tragarlo).
            let desc = '';
            try { const j = await r.json(); desc = j.description || j.message || ''; } catch (e2) {}
            throw new Error(desc || 'No se pudo añadir el producto.');
          }
        }, fd.get('id'));
      });
      await refreshCart();
      drawer?.classList.remove('is-loading');
      window.__rcAdding = false;
      if (btn) {
        btn.innerHTML = '<span aria-hidden="true">✓</span> <span style="margin-left:6px;">Añadido</span>';
        setTimeout(() => {
          if (!btn) return;
          btn.innerHTML = originalHTML;
          btn.removeAttribute('aria-busy');
          btn.removeAttribute('disabled');
        }, 1200);
      }
    } catch (err) {
      console.warn(err);
      window.__rcAdding = false;
      // Un 422 de stock es éxito PARCIAL (las unidades disponibles SÍ entraron): refrescar para
      // que el badge/drawer reflejen la verdad y DECIR al cliente qué ha pasado (antes: drawer
      // cerrado en seco sin mensaje → reintentos mudos y sorpresa en el checkout).
      try { await refreshCart(); } catch (e2) {}
      drawer?.classList.remove('is-loading');
      if (typeof showToast === 'function') showToast(err && err.message ? err.message : 'No se pudo añadir el producto.', 'error');
      if (btn) {
        btn.innerHTML = originalHTML;
        btn.removeAttribute('aria-busy');
        btn.removeAttribute('disabled');
      }
    }
  });

  // Guardia packs-a-elegir: un pack "huérfano" (sin properties._picks) entró SIN el builder
  // (quick-add antiguo, permalink externo) → el pedido llegaría sin la elección del cliente.
  // Solo aplica a los 3 packs A ELEGIR por handle: los packs fijos (Exterior/Interior/Básico)
  // no llevan _picks por diseño y NO deben bloquearse. Fail-open: si /cart.js tarda >1500ms
  // se sigue al checkout igualmente (misma filosofía que la guarda anti-cuelgue del pagar).
  const RC_CHOICE_PACKS = ['pack-3-a-elegir', 'pack-5-a-elegir', 'pack-10-a-elegir'];
  function rcFindOrphanPack() {
    const t = new Promise((res) => setTimeout(() => res(null), 1500));
    const q = fetch('/cart.js', { cache: 'no-store' }).then((r) => r.json()).catch(() => null);
    return Promise.race([t, q]).then((cart) => {
      if (!cart || !cart.items) return null;
      return cart.items.find((it) => RC_CHOICE_PACKS.indexOf(it.handle) >= 0 && !(it.properties && it.properties._picks)) || null;
    }).catch(() => null);
  }
  function rcOrphanMsg() {
    const L = ((document.documentElement.lang || 'es') + '').slice(0, 2);
    const M = {
      es: "Te falta elegir los productos de tu pack — te llevamos a la selección.",
      fr: "Il te reste à choisir les produits de ton pack — on t'y emmène.",
      it: "Devi ancora scegliere i prodotti del tuo pack — ti portiamo alla selezione.",
      pt: "Falta escolheres os produtos do teu pack — vamos levar-te à seleção.",
      de: "Du musst noch die Produkte deines Packs wählen — wir bringen dich zur Auswahl.",
      nl: "Kies nog de producten van je pack — we brengen je ernaartoe."
    };
    return M[L] || M.es;
  }

  // Buy Now: add to cart and go directly to checkout
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-buy-now]');
    if (!btn) return;
    e.preventDefault();
    const form = btn.closest('form[action="/cart/add"]');
    if (!form) return;
    // Guard anti doble-add: bloquea doble compra; se mantiene true hasta el redirect
    if (window.__rcAdding) return;
    window.__rcAdding = true;
    const originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span style="display:inline-block;width:16px;height:16px;border:2px solid currentColor;border-top-color:transparent;border-radius:50%;animation:spin .8s linear infinite;"></span> Procesando...';
    try {
      const fd = new FormData(form);
      await runCartOp(function () {
        return withGiftless(async () => {
          const r = await fetch('/cart/add.js', { method: 'POST', body: fd });
          if (!r.ok) {
            const err = await r.json().catch(() => ({}));
            throw new Error(err.description || 'add failed');
          }
        }, fd.get('id'));
      });
      // Respeta el locale/market: si el visitante está en /pt, /fr, /it…, ir al checkout localizado.
      // Sin esto, /checkout fija ES y rompe IVA/idioma para 5 markets non-ES.
      const rootBase = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/').replace(/\/$/, '');
      // Pack a-elegir sin elección en el carrito → completar la selección antes de pagar.
      const orphan = await rcFindOrphanPack();
      if (orphan) {
        window.__rcAdding = false;
        btn.disabled = false;
        btn.innerHTML = originalHTML;
        showToast(rcOrphanMsg(), 'error');
        setTimeout(function () { window.location.href = rootBase + '/products/' + orphan.handle; }, 400);
        return;
      }
      window.location.href = rootBase + '/checkout';
    } catch (err) {
      console.warn('Buy now failed:', err);
      window.__rcAdding = false;
      btn.disabled = false;
      btn.innerHTML = originalHTML;
      try { await refreshCart(); } catch (e2) {} // en 422 parcial las unidades SÍ entraron: reflejarlo
      showToast('No se ha podido procesar la compra. Inténtalo de nuevo.', 'error');
    }
  });

  // Expuesta global para que handlers en main-product.liquid (bundle, sticky ATC) la reutilicen
  window.rcRefreshCart = refreshCart;

  // Añadir al carrito GIFT-AWARE + serializado + refresco. Lo usan bundle y sticky ATC de main-product.liquid
  // (que antes hacían fetch directo a /cart/add.js y desdoblaban la línea con el regalo/Bxgy activo).
  window.rcCartAdd = function (items) {
    return runCartOp(function () {
      return withGiftless(async () => {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
        if (!r.ok) throw new Error('add failed');
      }, null);
    }).then(function () { return refreshCart(); });
  };

  // NOTA: el antiguo mergeSplitLines (fusionar líneas partidas REESCRIBIENDO el carrito) se
  // eliminó: re-añadir el regalo tras fusionar podía volver a partir la línea → bucle de
  // reconciliación (el carrito "pensaba" 10+ segundos y quedaba dividido). La fusión ahora es
  // VISUAL: cart-drawer/main-cart agrupan las líneas del mismo variant en una sola fila y el
  // stepper fija la cantidad TOTAL del grupo (updateCartLine ya reconstruye multi-línea).

  async function refreshCart() {
    try {
      // Disparar AMBOS fetches en paralelo + Section Rendering API moderna (sections=)
      // que devuelve JSON pequeño en lugar de HTML completo (más rápido en mobile)
      const cb = Date.now();
      // Prefijo de market/idioma (Shopify.routes.root ya termina en '/'): sin él,
      // el drawer se re-renderiza desde el market primario ES (tarifa/zona/textos ES en /pt-pt, /fr-fr, etc.)
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      // Si estamos en la página de carrito, re-renderizamos su sección EN SITIO (sin location.reload)
      const cartPageEl = document.querySelector('[data-cart-page]');
      const cartSectionId = cartPageEl ? cartPageEl.getAttribute('data-section-id') : null;
      let sectionsParam = 'cart-drawer';
      if (cartSectionId) sectionsParam += ',' + cartSectionId;
      const [cartRes, sectionRes] = await Promise.all([
        fetch('/cart.js?t=' + cb, { cache: 'no-store' }).catch(() => null),
        fetch(root + 'cart?sections=' + encodeURIComponent(sectionsParam) + '&t=' + cb, { cache: 'no-store' }).catch(() => null),
      ]);
      const cart = cartRes && cartRes.ok ? await cartRes.json() : null;
      if (cart) {
        $$('[data-cart-count]').forEach(el => {
          const prev = parseInt(el.textContent, 10) || 0;
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
          if (cart.item_count > prev) {
            el.classList.remove('cart-count--bump');
            // eslint-disable-next-line no-void
            void el.offsetWidth;
            el.classList.add('cart-count--bump');
          }
        });
      }
      let html = null;
      let pageHtml = null;
      if (sectionRes && sectionRes.ok) {
        try {
          const txt = await sectionRes.text();
          // Section Rendering API devuelve JSON con la key "cart-drawer"; fallback a text si no es JSON
          if (txt.trim().startsWith('{')) {
            const j = JSON.parse(txt);
            html = j['cart-drawer'] || null;
            if (cartSectionId) pageHtml = j[cartSectionId] || null;
          } else {
            html = txt;
          }
        } catch (e) { html = null; }
      }
      if (typeof html === 'string' && html.length > 0) {
        try {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-cart-drawer]');
          const current = $('[data-cart-drawer]');
          if (fresh && current) {
            const wasOpen = current.classList.contains('is-open');
            // El swap destruía el input ENFOCADO sin preservar nada: lo tecleado se perdía en
            // silencio (sin change) y el valor "saltaba atrás". Capturar antes / restaurar después.
            const act = document.activeElement;
            const actWrap = act && act.closest ? act.closest('[data-cart-qty]') : null;
            const actVid = actWrap && actWrap.dataset.key ? String(actWrap.dataset.key).split(':')[0] : null;
            const actVal = actVid ? act.value : null;
            current.innerHTML = fresh.innerHTML;
            if (wasOpen) current.classList.add('is-open');
            // Re-aplicar valores PENDIENTES (debounce aún sin volcar) para que el input no muestre
            // el estado viejo del servidor mientras la escritura está en vuelo.
            try {
              Object.keys(qtyPending).forEach(function (vid) {
                const inp = current.querySelector('[data-cart-qty][data-key^="' + vid + ':"] input[type="number"]');
                if (inp) inp.value = qtyPending[vid];
              });
            } catch (e) {}
            if (actVid) {
              const again = current.querySelector('[data-cart-qty][data-key^="' + actVid + ':"] input[type="number"]');
              if (again) {
                // Conservar lo tecleado SOLO mientras el cambio sigue en vuelo (qtyPending).
                // Si el servidor ya respondió (p.ej. capó a stock máximo, 494), el input debe
                // mostrar la VERDAD del carrito — restaurar el valor tecleado dejaba un
                // desajuste permanente (input 500 / carrito 494 = "se buguea").
                if (actVal !== null && actVal !== '' && qtyPending[actVid] !== undefined) again.value = actVal;
                try { again.focus(); again.setSelectionRange(String(again.value).length, String(again.value).length); } catch (e) {}
              }
            }
            // J05 — stagger cart-line entrance after re-render
            const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (!reducedMotion) {
              const lines = current.querySelectorAll('.cart-line');
              lines.forEach((ln, i) => {
                ln.style.setProperty('--i', i);
                ln.classList.add('cart-line--new');
                const cleanup = () => { ln.classList.remove('cart-line--new'); ln.style.removeProperty('--i'); ln.removeEventListener('animationend', cleanup); };
                ln.addEventListener('animationend', cleanup);
              });
            }
          }
        } catch (parseErr) { console.warn('cart-drawer parse failed', parseErr); }
      }
      // Re-render de la página de carrito EN SITIO (sin recargar). Conserva el foco del stepper activo.
      if (cartPageEl && typeof pageHtml === 'string' && pageHtml.length > 0) {
        const wrapper = document.getElementById('shopify-section-' + cartSectionId);
        if (wrapper) {
          const active = document.activeElement;
          const activeQty = active && active.closest ? active.closest('[data-qty]') : null;
          const activeVid = activeQty && activeQty.getAttribute('data-key') ? String(activeQty.getAttribute('data-key')).split(':')[0] : null;
          const activeVal = activeVid ? active.value : null;
          wrapper.innerHTML = pageHtml;
          // innerHTML NO ejecuta <script>: los recreamos para reactivar cupón/sticky/ETA de la sección.
          wrapper.querySelectorAll('script').forEach(function (old) {
            const s = document.createElement('script');
            for (let i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
            s.textContent = old.textContent;
            old.parentNode.replaceChild(s, old);
          });
          // Igual que en el drawer: re-aplicar valores pendientes y restaurar VALOR+foco del
          // input activo (por variante: las keys cambian entre re-renders). Antes solo se
          // restauraba el foco y el número tecleado "saltaba atrás" a mitad de escritura.
          try {
            Object.keys(qtyPending).forEach(function (vid) {
              const inp = wrapper.querySelector('[data-qty][data-key^="' + vid + ':"] input[type="number"]');
              if (inp) inp.value = qtyPending[vid];
            });
          } catch (e) {}
          if (activeVid) {
            const again = wrapper.querySelector('[data-qty][data-key^="' + activeVid + ':"] input[type="number"]');
            if (again) {
              // Igual que en el drawer: lo tecleado solo se conserva mientras hay op en vuelo.
              if (activeVal !== null && activeVal !== '' && qtyPending[activeVid] !== undefined) again.value = activeVal;
              try { again.focus(); again.setSelectionRange(String(again.value).length, String(again.value).length); } catch (e) {}
            }
          }
        }
      }
      // Notifica componentes que escuchan cambios de carrito (PDP ship-bar, etc.)
      try { document.dispatchEvent(new CustomEvent('rc:cart:changed', { detail: cart })); } catch (e) {}
    } catch (e) { console.warn('refreshCart', e); }
  }

  // Ejecuta una escritura de carrito SIN el regalo presente y luego lo repone.
  // Un Bxgy (regalo) activo hace que Shopify PARTA la línea al aumentar/añadir unidades (crea una 2ª
  // fila = "duplicado", p.ej. 200 uds → 4 + 196). Pasa tanto al subir un producto ya presente como al
  // AÑADIR de golpe muchas unidades de un producto de la colección "buys" del regalo. Por eso quitamos
  // SIEMPRE el regalo antes de escribir (no solo si el producto ya estaba); luego lo reponemos igual
  // (gift-auto reconcilia el tramo). addingVariantId se conserva por compatibilidad, ya no condiciona.
  async function withGiftless(fn, addingVariantId) {
    let removed = [];
    try {
      const cart = await (await fetch('/cart.js', { cache: 'no-store' })).json();
      const gifts = (cart.items || []).filter(it => it.properties && it.properties._regalo);
      if (gifts.length) {
        removed = gifts;
        for (const g of removed) {
          await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: g.key, quantity: 0 }) });
        }
      }
    } catch (e) {}
    try {
      await fn();
    } finally {
      for (const g of removed) {
        try { await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: g.variant_id, quantity: g.quantity, properties: g.properties }] }) }); } catch (e) {}
      }
    }
  }

  // Fija la cantidad de una línea de carrito de forma DETERMINISTA: deja la variante en UNA sola línea
  // con exactamente `quantity` unidades. No depende de keys frágiles (Shopify las regenera al quitar el
  // regalo Bxgy y el re-resolver fallaba en saltos grandes → el cambio no se aplicaba). Con un Bxgy de
  // regalo activo Shopify también PARTE la línea al subir cantidad, así que quitamos el regalo, dejamos
  // la variante en 1 línea con la cantidad pedida, y reponemos el regalo. Sobre cualquier fallo (p.ej.
  // stock), refrescamos igual para reconciliar el input a la cantidad real (no dejarlo mostrando un valor falso).
  async function updateCartLine(key, quantity) {
    const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    try {
      const variantId = String(key).split(':')[0];
      quantity = Math.max(0, parseInt(quantity, 10) || 0);
      const cart = await (await fetch('/cart.js', { cache: 'no-store' })).json();
      const isG = it => it.properties && it.properties._regalo;
      const isPk = it => it.product_type === 'Pack' || it.handle === 'pack-3-a-elegir' || it.handle === 'pack-5-a-elegir' || it.handle === 'pack-10-a-elegir' || (it.properties && it.properties._picks);
      const gifts = cart.items.filter(isG);
      const hasPack = cart.items.some(isPk);
      // TODAS las líneas de esta variante (por si Shopify la partió), sin contar regalos
      const sameVar = cart.items.filter(it => String(it.variant_id) === variantId && !isG(it));

      // Bajar a 0 → quitar todas las líneas de la variante
      if (quantity <= 0) {
        clearQtyTimersFor(variantId); // matar updates debounced pendientes: que no resuciten la línea
        for (const l of sameVar) await post('/cart/change.js', { id: l.key, quantity: 0 });
        await refreshCart();
        return;
      }
      // Línea ya borrada (la papelera ganó a un update debounced pendiente): NO resucitarla (zombi).
      if (sameVar.length === 0) { await refreshCart(); return; }
      // NO-OP: ya está exactamente así (un change duplicado del mismo valor no debe re-escribir:
      // el rebuild innecesario con regalo era una de las fuentes de duplicación).
      if (sameVar.length === 1 && sameVar[0].quantity === quantity) { return; }
      // Camino directo con key FRESCA (leída en ESTA op): sin regalo no hay split; y BAJAR
      // cantidad tampoco parte la línea aunque haya regalo.
      if (sameVar.length === 1 && (!gifts.length || quantity < sameVar[0].quantity)) {
        const r = await post('/cart/change.js', { id: sameVar[0].key, quantity: quantity });
        if (!r.ok) throw new Error('change failed');
        // change.js CAPA en silencio al stock disponible: si se pidió más de lo que hay
        // (p.ej. 500 con 494 en stock), avisar — sin esto el número "no obedece" sin explicación.
        try {
          const jc = await r.json();
          const got = (jc.items || []).filter(it => String(it.variant_id) === variantId && !isG(it)).reduce((s, it) => s + it.quantity, 0);
          if (got < quantity) showToast('Solo quedan ' + got + ' unidades en stock — hemos ajustado tu carrito.', 'error');
        } catch (e3) {}
        await refreshCart();
        return;
      }
      // SUBIR con regalo (el change partiría la línea) o línea ya partida → rebuild seguro.
      // 1) Quitar regalos (sus keys del snapshot siguen vivas: nada las ha regenerado aún).
      if (gifts.length && !hasPack) {
        for (const g of gifts) {
          const rg = await post('/cart/change.js', { id: g.key, quantity: 0 });
          if (!rg.ok) throw new Error('gift remove failed');
        }
      }
      // 2) RE-LEER: quitar el regalo REGENERA las keys del resto de líneas. Usar las del
      //    snapshot viejo era EL BUG: los change a 0 daban 404 silencioso y el add sumaba
      //    encima (12→24, 200→412). Keys frescas + verificación en cada paso.
      const c2 = await (await fetch('/cart.js', { cache: 'no-store' })).json();
      const freshLines = c2.items.filter(it => String(it.variant_id) === variantId && !isG(it));
      const props = (freshLines[0] && freshLines[0].properties) || {};
      for (const l of freshLines) {
        const rz = await post('/cart/change.js', { id: l.key, quantity: 0 });
        if (!rz.ok) throw new Error('zero failed'); // abortar: JAMÁS añadir sobre líneas no borradas
      }
      const ra = await post('/cart/add.js', { items: [{ id: parseInt(variantId, 10), quantity: quantity, properties: props }] });
      if (!ra.ok) {
        // 422 de stock = éxito PARCIAL (Shopify metió el máximo disponible). Avisar y reconciliar.
        let desc = '';
        try { const je = await ra.json(); desc = je.description || ''; } catch (e4) {}
        showToast(desc || 'No hay stock suficiente — hemos ajustado tu carrito al máximo disponible.', 'error');
        await refreshCart();
        return;
      }
      // 3) NO re-añadir el regalo aquí: gift-auto (serializado en la misma cadena) reconcilia
      //    el tramo tras rc:cart:changed — un solo dueño del ciclo de vida del regalo.
      await refreshCart();
    } catch (e) { console.warn(e); try { await refreshCart(); } catch (e2) {} }
  }

  // Serializa TODAS las escrituras de carrito (evita solapes que corromperían el estado).
  // La cadena sigue viva pase lo que pase, pero el llamante recibe el error real (para su try/catch).
  // __rcCartBusy: contador expuesto para que gift-auto NO escriba mientras el tema escribe
  // (la carrera gift-auto ↔ op del tema es lo que parte líneas al añadir muchas unidades).
  window.__rcCartBusy = 0;
  var cartOpChain = Promise.resolve();
  function runCartOp(fn) {
    const run = cartOpChain.then(function () {
      window.__rcCartBusy = (window.__rcCartBusy || 0) + 1;
      return Promise.resolve().then(fn).finally(function () {
        window.__rcCartBusy = Math.max(0, (window.__rcCartBusy || 1) - 1);
      });
    });
    cartOpChain = run.catch(function () {});
    return run;
  }
  // Expuesta para que gift-auto encole sus escrituras en la MISMA cadena (la exclusión por
  // __rcCartBusy era unidireccional y con ventana: gift-auto podía escribir a mitad de una op).
  window.rcRunCartOp = runCartOp;

  // Debounce de cantidad + COALESCING por variante: qtyPending[vid] guarda el último valor deseado.
  // Una op encolada solo se ejecuta si sigue siendo la vigente (si el usuario siguió clicando, la
  // vieja se salta) → ráfagas con pausas ya no encolan N cadenas completas de 8-9 requests.
  var qtyTimers = {};
  var qtyPending = {}; // vid -> última cantidad pedida por el usuario aún no aplicada
  function fireScheduled(key, value) {
    const vid = String(key).split(':')[0];
    runCartOp(function () {
      if (qtyPending[vid] !== value) return; // llegó un valor más nuevo: esta op ya no aplica
      delete qtyPending[vid];
      return updateCartLine(key, value);
    });
  }
  function scheduleCartUpdate(key, value) {
    const vid = String(key).split(':')[0];
    qtyPending[vid] = value;
    if (qtyTimers[key]) clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () { delete qtyTimers[key]; fireScheduled(key, value); }, 450);
  }
  // Vuelca YA todos los updates pendientes (sin esperar el debounce) y devuelve la cadena.
  function flushQtyTimers() {
    Object.keys(qtyTimers).forEach(function (k) {
      clearTimeout(qtyTimers[k]);
      const vid = String(k).split(':')[0];
      const v = qtyPending[vid];
      delete qtyTimers[k];
      if (v !== undefined) fireScheduled(k, v);
    });
    return runCartOp(function () {}); // barrera: resuelve cuando la cadena queda vacía
  }
  // Cancela TODOS los timers pendientes de una variante (las keys cambian cuando el Bxgy se mueve,
  // así que un mismo producto puede tener timers bajo keys distintas). Se llama al borrar la línea:
  // sin esto, un update debounced pendiente re-añadía el producto recién borrado (zombi cobrable).
  function clearQtyTimersFor(keyOrVariant) {
    const vid = String(keyOrVariant).split(':')[0];
    delete qtyPending[vid];
    Object.keys(qtyTimers).forEach(function (k) {
      if (String(k).split(':')[0] === vid) { clearTimeout(qtyTimers[k]); delete qtyTimers[k]; }
    });
  }

  // Qty steppers
  document.addEventListener('click', (e) => {
    const inc = e.target.closest('[data-qty-inc]');
    const dec = e.target.closest('[data-qty-dec]');
    if (!inc && !dec) return;
    const wrap = e.target.closest('[data-qty]');
    const input = wrap?.querySelector('input[type="number"]');
    if (!input) return;
    e.preventDefault();
    let v = parseInt(input.value, 10) || 1;
    const min = parseInt(input.min, 10);
    const minVal = isNaN(min) ? 1 : min;
    v = inc ? v + 1 : Math.max(minVal, v - 1);
    input.value = v;

    // Si el qty está en cart drawer o cart page, sincroniza con el servidor
    // (no disparamos 'change' aquí para evitar doble fetch desde el listener change)
    const cartQty = wrap.dataset.cartQty !== undefined ? wrap : null;
    if (cartQty) {
      const key = wrap.dataset.key;
      if (key) scheduleCartUpdate(key, v);
    } else {
      // Fuera de cart, disparamos change para PDP qty-breaks / sub-form listeners
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // Direct typing in cart drawer qty input
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-qty] input[type="number"]');
    if (!input) return;
    const wrap = input.closest('[data-qty]');
    const key = wrap?.dataset.key;
    if (!key) return;
    const raw = String(input.value || '').trim();
    // Vaciar el campo para reescribir NO es "0": restaurar el valor del servidor, sin tocar el carrito.
    if (raw === '') { input.value = input.defaultValue || input.getAttribute('value') || 1; return; }
    const v = parseInt(raw, 10) || 0;
    if (v <= 0) {
      // 0 explícito = quitar la línea, SERIALIZADO como el resto (antes corría fuera de la cadena
      // y se solapaba con updates/gift-auto → líneas partidas y regalos duplicados).
      clearQtyTimersFor(key);
      runCartOp(function () { return updateCartLine(key, 0); });
    } else { scheduleCartUpdate(key, v); }
  });

  // Checkout de carrito (drawer y página): SIEMPRE por navegación directa tras volcar los
  // updates pendientes. Razones: (1) el submit nativo mataba el debounce → se pagaba la cantidad
  // VIEJA; (2) el POST nativo con updates[key] puede llevar keys OBSOLETAS (el Bxgy las regenera);
  // (3) form.submit() sobre un form desconectado por un re-render NO navega (checkout muerto).
  // Enter en un input del form (submit implícito, e.submitter null) NO es "ir a pagar": el
  // cliente está fijando una cantidad → volcamos el cambio y nos quedamos donde estamos.
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart') === -1) return;
    if (form.action.indexOf('/cart/add') !== -1) return; // los ATC los gestiona su propio handler
    if (!form.querySelector('button[name="checkout"]')) return;
    const explicitCheckout = !!(e.submitter && e.submitter.name === 'checkout');
    e.preventDefault();
    if (!explicitCheckout) { flushQtyTimers().catch(function () {}); return; }
    const sub = e.submitter;
    if (sub) { sub.disabled = true; sub.setAttribute('aria-busy', 'true'); }
    const rootBase = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
    let navigated = false;
    const goCheckout = function () { if (navigated) return; navigated = true; window.location.assign(rootBase + '/checkout'); };
    // Guarda anti-cuelgue: si un update de red queda pendiente (móvil con mala cobertura),
    // vamos al pago igualmente pasados 2,5s en vez de dejar el botón bloqueado.
    const guard = setTimeout(goCheckout, 2500);
    flushQtyTimers().catch(function () {})
      .then(function () { return rcFindOrphanPack(); })
      .then(function (orphan) {
        clearTimeout(guard);
        if (orphan && !navigated) {
          // Pack a-elegir sin elección: no dejamos que el pedido llegue ciego.
          navigated = true;
          if (sub) { sub.disabled = false; sub.removeAttribute('aria-busy'); }
          showToast(rcOrphanMsg(), 'error');
          setTimeout(function () { window.location.assign(rootBase + '/products/' + orphan.handle); }, 400);
          return;
        }
        goCheckout();
      });
  });

  // Remove from cart drawer
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    const key = btn.dataset.key;
    if (!key) return;
    btn.disabled = true;
    clearQtyTimersFor(key); // que un update pendiente no resucite la línea borrada
    await runCartOp(function () { return updateCartLine(key, 0); });
  });

  // Cart page remove link (anchor)
  document.addEventListener('click', async (e) => {
    const link = e.target.closest('[data-remove-link]');
    if (!link) return;
    e.preventDefault();
    const url = new URL(link.href, location.origin);
    const id = url.searchParams.get('id');
    if (!id) return;
    clearQtyTimersFor(id);
    await runCartOp(function () { return updateCartLine(id, 0); });
  });

  // Product gallery thumbs — keep responsive srcset on switch
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-thumb]');
    if (!t) return;
    const main = $('[data-product-main-image]');
    if (main) {
      const src = t.dataset.src;
      main.src = src;
      // Rebuild srcset from same image at multiple widths (Shopify CDN supports ?width=)
      const base = src.split('?')[0];
      main.srcset = `${base}?width=480 480w, ${base}?width=800 800w, ${base}?width=1200 1200w`;
    }
    $$('[data-thumb]').forEach(el => el.classList.toggle('is-active', el === t));
  });

  // TOC autogenerada en artículos largos
  const tocList = $('[data-toc-list]');
  const articleContent = $('[data-article-content]');
  if (tocList && articleContent) {
    const headings = $$('h2', articleContent);
    if (headings.length >= 3) {
      tocList.innerHTML = '';
      headings.forEach((h, i) => {
        if (!h.id) {
          h.id = 'h-' + (h.textContent || ('s' + i)).toLowerCase()
            .replace(/[áàä]/g, 'a').replace(/[éèë]/g, 'e').replace(/[íìï]/g, 'i')
            .replace(/[óòö]/g, 'o').replace(/[úùü]/g, 'u').replace(/ñ/g, 'n')
            .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 50);
        }
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        tocList.appendChild(li);
      });
    } else {
      const toc = $('[data-article-toc]');
      if (toc) toc.style.display = 'none';
    }
  }

  // Reading progress bar (artículos blog)
  // Scroll envuelto en requestAnimationFrame para evitar layout thrash en
  // artículos largos (INP friendly).
  const progressFill = $('[data-article-progress]');
  if (progressFill) {
    let ticking = false;
    const update = () => {
      const article = $('.article__body');
      if (!article) return;
      const rect = article.getBoundingClientRect();
      const total = article.offsetHeight - window.innerHeight;
      const scrolled = Math.min(Math.max(-rect.top, 0), total);
      progressFill.style.width = total > 0 ? (scrolled / total * 100) + '%' : '0%';
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { update(); ticking = false; });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  // Segmentación B2C/B2B en forms de captación.
  // Si el form tiene un checkbox [data-pro-segment] marcado, añade
  // `b2b-interested` al hidden input contact[tags] antes de enviar.
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-segment-form]');
    if (!form) return;
    const proCheckbox = form.querySelector('[data-pro-segment]');
    if (!proCheckbox || !proCheckbox.checked) return;
    const tagsInput = form.querySelector('input[name="contact[tags]"]');
    if (!tagsInput) return;
    const current = tagsInput.value.split(',').map(s => s.trim()).filter(Boolean);
    if (!current.includes('b2b-interested')) current.push('b2b-interested');
    tagsInput.value = current.join(',');
  }, true); // captura: corre antes que el submit nativo

  // Helpers compartidos (recently-viewed, predictive search)
  function escapeHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }
  function formatMoney(cents, currency) {
    try { return new Intl.NumberFormat('es-ES', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }

  // ==========================================================
  // Recently viewed products (P2.15)
  // Guarda IDs visitados en localStorage. En PDP guarda el producto.
  // Renderiza la sección [data-recently-viewed] con un fetch por handle.
  // ==========================================================
  const RV_KEY = 'rc_recently_viewed';
  function rvList() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; }
  }
  function rvAdd(handle) {
    if (!handle) return;
    let list = rvList().filter(h => h !== handle);
    list.unshift(handle);
    list = list.slice(0, 12);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (e) {}
  }
  // Auto-track en PDP
  const pdpHandle = document.body.dataset.productHandle || (document.querySelector('meta[property="product:retailer_part_no"]') ? null : null);
  if (window.__rcProductHandle) rvAdd(window.__rcProductHandle);
  // Render
  const rvSection = $('[data-recently-viewed]');
  if (rvSection) {
    const grid = rvSection.querySelector('[data-recently-viewed-grid]');
    const limit = parseInt(rvSection.dataset.limit, 10) || 4;
    const currentHandle = window.__rcProductHandle;
    const handles = rvList().filter(h => h !== currentHandle).slice(0, limit);
    if (handles.length && grid) {
      Promise.all(handles.map(h => fetch('/products/' + encodeURIComponent(h) + '.js').then(r => r.ok ? r.json() : null).catch(() => null)))
        .then(products => {
          const valid = products.filter(Boolean);
          if (!valid.length) return;
          grid.innerHTML = valid.map(p => {
            const img = p.featured_image ? (p.featured_image.startsWith('//') ? 'https:' + p.featured_image : p.featured_image) : '';
            return '<a class="rv-item" href="/products/' + escapeHTML(p.handle) + '">' +
              '<div class="rv-item__media">' + (img ? '<img src="' + escapeHTML(img) + '" alt="' + escapeHTML(p.title) + '" loading="lazy" width="600" height="600">' : '') + '</div>' +
              '<div class="rv-item__info">' +
                '<div class="rv-item__title">' + escapeHTML(p.title) + '</div>' +
                '<div class="rv-item__price">' + formatMoney(p.price, 'EUR') + '</div>' +
              '</div>' +
            '</a>';
          }).join('');
          rvSection.hidden = false;
        });
    }
  }

  // ==========================================================
  // Predictive search (P2.16)
  // Abre drawer con [data-search-open], hace fetch a Shopify Predictive
  // Search API y muestra hasta 6 productos. Enter envía al listado completo.
  // ==========================================================
  const searchDrawer = $('[data-search-drawer]');
  const searchInput = $('[data-search-input]');
  const searchResults = $('[data-search-results]');
  let searchTimer = null;
  function openSearch() {
    if (!searchDrawer) return;
    searchDrawer.hidden = false;
    rcLockScroll();
    $$('[data-search-open]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    setTimeout(() => searchInput && searchInput.focus(), 50);
  }
  function closeSearch() {
    if (!searchDrawer || searchDrawer.hidden) return;
    searchDrawer.hidden = true;
    rcUnlockScroll();
    $$('[data-search-open]').forEach(b => b.setAttribute('aria-expanded', 'false'));
  }
  function renderSearch(data, q) {
    if (!searchResults) return;
    const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    if (!products.length) {
      searchResults.innerHTML = '<div class="rc-search__empty">No hay resultados para "' + escapeHTML(q) + '". Prueba con otra palabra.</div>';
      return;
    }
    const items = products.slice(0, 6).map(p => {
      const img = p.image || (p.featured_image && p.featured_image.url) || '';
      return '<a class="rc-search__item" href="' + escapeHTML(p.url) + '">' +
        (img ? '<img src="' + escapeHTML(img) + '" alt="" loading="lazy">' : '<div style="width:48px;height:48px;background:#eee;border-radius:8px"></div>') +
        '<div class="rc-search__item-info">' +
          '<div class="rc-search__item-title">' + escapeHTML(p.title) + '</div>' +
          '<div class="rc-search__item-price">' + escapeHTML(p.price || '') + '</div>' +
        '</div>' +
      '</a>';
    }).join('');
    searchResults.innerHTML = '<div class="rc-search__group"><h3>Productos</h3>' + items + '</div>' +
      '<a class="rc-search__view-all" href="/search?q=' + encodeURIComponent(q) + '">Ver todos los resultados →</a>';
  }
  function debouncedSearch(q) {
    clearTimeout(searchTimer);
    if (!q || q.length < 2) {
      if (searchResults) searchResults.innerHTML = '';
      return;
    }
    searchTimer = setTimeout(() => {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(r => r.json())
        .then(data => renderSearch(data, q))
        .catch(() => {});
    }, 200);
  }
  if (searchInput) searchInput.addEventListener('input', (e) => debouncedSearch(e.target.value.trim()));
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); return; }
    if (e.target.closest('[data-search-close]')) { closeSearch(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchDrawer && !searchDrawer.hidden) closeSearch();
    if (e.key === '/' && document.activeElement && !['INPUT','TEXTAREA','SELECT'].includes(document.activeElement.tagName)) {
      e.preventDefault();
      openSearch();
    }
  });

  // ==========================================================
  // Cookie consent reopen link y collection sort (P2.20)
  // Migra los onclick="" inline a delegación para CSP-readiness.
  // ==========================================================
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-open-consent]');
    if (!link) return;
    e.preventDefault();
    if (typeof window.rcOpenConsent === 'function') window.rcOpenConsent();
  });
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-auto-submit]');
    if (sel && sel.form) sel.form.submit();
  });
  document.addEventListener('click', (e) => {
    const tog = e.target.closest('[data-toggle-target]');
    if (!tog) return;
    e.preventDefault();
    const sel = tog.getAttribute('data-toggle-target');
    const target = sel && document.querySelector(sel);
    if (target) target.style.display = target.style.display === 'none' ? 'block' : 'none';
  });

  // Initial cart count fetch — deferred to idle to not compete with LCP
  const fetchCart = () => fetch('/cart.js').then(r => r.json()).then(cart => {
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
  }).catch(() => {});
  if ('requestIdleCallback' in window) requestIdleCallback(fetchCart, { timeout: 2000 });
  else setTimeout(fetchCart, 1500);

  // Cleanup timers/listeners on unload to avoid leaks in long sessions / bfcache
  window.addEventListener('beforeunload', () => {
    try { if (searchTimer) clearTimeout(searchTimer); } catch (e) {}
  }, { once: true });

  // ==========================================================
  // J01 — IntersectionObserver: scroll-reveal para .fade-up / .fade-up-stagger
  // ==========================================================
  (function fadeUpObserver(){
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      $$('.fade-up, .fade-up-stagger').forEach(function(el){ el.classList.add('is-visible'); });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      $$('.fade-up, .fade-up-stagger').forEach(function(el){ el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.classList.contains('fade-up-stagger')) {
          Array.from(el.children).forEach(function(child, i){ child.style.setProperty('--i', i); });
        }
        el.classList.remove('fade-pending');
        el.classList.add('is-visible');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    // PERF: solo se oculta (fade-pending) lo que YA está fuera de la ventana
    // visible en este instante — lo above-the-fold pinta al instante (LCP
    // intacto) y el fade-on-scroll de más abajo sigue igual que siempre.
    var observeAll = function(scope){
      var ctx = scope || document;
      ctx.querySelectorAll('.fade-up, .fade-up-stagger').forEach(function(el){
        if (el.classList.contains('is-visible')) return;
        if (el.getBoundingClientRect().top > window.innerHeight) {
          el.classList.add('fade-pending');
        }
        io.observe(el);
      });
    };
    observeAll();
    // Re-observe dinámicos (cart drawer, ajax). Expone helper:
    window.rcObserveFadeUp = observeAll;
  })();

  // ==========================================================
  // J08 — Per-field validation en .form-field (aria-invalid en blur, clear en input)
  // ==========================================================
  (function fieldValidation(){
    function validate(el){
      if (!el.willValidate) return true;
      var ok = el.checkValidity();
      el.setAttribute('aria-invalid', ok ? 'false' : 'true');
      // Mensaje inline opcional
      var wrap = el.closest('.form-field, .pro-form__field');
      if (wrap) {
        var errEl = wrap.querySelector('.form-field__error');
        if (!ok) {
          if (!errEl) {
            errEl = document.createElement('span');
            errEl.className = 'form-field__error';
            wrap.appendChild(errEl);
          }
          errEl.textContent = el.validationMessage || 'Campo inválido';
        } else if (errEl) {
          errEl.remove();
        }
      }
      return ok;
    }
    document.addEventListener('blur', function(e){
      var el = e.target;
      if (!el || !el.matches) return;
      if (!el.matches('.form-field input, .form-field select, .form-field textarea, .pro-form__field input, .pro-form__field select, .pro-form__field textarea')) return;
      validate(el);
    }, true);
    document.addEventListener('input', function(e){
      var el = e.target;
      if (!el || !el.matches) return;
      if (!el.matches('.form-field input, .form-field textarea, .pro-form__field input, .pro-form__field textarea')) return;
      if (el.getAttribute('aria-invalid') === 'true') validate(el);
    });
  })();

  // ==========================================================
  // J09 — Loading state genérico en forms con .form-submit-loading
  // ==========================================================
  (function formSubmitLoading(){
    document.addEventListener('submit', function(e){
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains('form-submit-loading')) return;
      var btn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (!btn) return;
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('disabled', 'true');
    });
    window.addEventListener('pageshow', function(){
      $$('.form-submit-loading button[aria-busy="true"], .form-submit-loading input[aria-busy="true"]').forEach(function(btn){
        btn.removeAttribute('aria-busy');
        btn.removeAttribute('disabled');
      });
    });
  })();

  // ==========================================================
  // J10 — Hold-press en qty buttons (mousedown 400ms → repetir cada 80ms)
  // ==========================================================
  (function qtyHoldPress(){
    var holdTimer = null;
    var repeatTimer = null;
    function stop(){
      if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
      if (repeatTimer) { clearInterval(repeatTimer); repeatTimer = null; }
    }
    document.addEventListener('mousedown', function(e){
      var btn = e.target.closest('[data-qty-inc], [data-qty-dec]');
      if (!btn) return;
      var wrap = btn.closest('[data-qty]');
      var input = wrap && wrap.querySelector('input[type="number"]');
      if (!input) return;
      var isInc = btn.matches('[data-qty-inc]');
      var min = parseInt(input.min, 10);
      var minVal = isNaN(min) ? 1 : min;
      // OJO: el drawer se re-renderiza por innerHTML a mitad de una pulsación larga → el input
      // capturado queda DESCONECTADO y sus 'change' ya no burbujean a document (incrementos
      // perdidos en silencio, el carrito se quedaba en el valor pre-swap). En cada tick,
      // re-consultar el input VIVO por su variante; si no existe ya, parar.
      var keyVid = wrap.dataset.key ? String(wrap.dataset.key).split(':')[0] : null;
      holdTimer = setTimeout(function(){
        repeatTimer = setInterval(function(){
          var live = input;
          if (!input.isConnected) {
            live = keyVid ? document.querySelector('[data-cart-qty][data-key^="' + keyVid + ':"] input[type="number"]') : null;
            if (!live) { stop(); return; }
            input = live;
          }
          var v = parseInt(live.value, 10) || 1;
          v = isInc ? v + 1 : Math.max(minVal, v - 1);
          live.value = v;
          live.dispatchEvent(new Event('change', { bubbles: true }));
        }, 80);
      }, 400);
    });
    document.addEventListener('mouseup', stop);
    document.addEventListener('mouseleave', stop, true);
    document.addEventListener('touchend', stop);
    document.addEventListener('touchcancel', stop);
  })();
})();
